import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpIconComponentSVGComponent } from './fcp-icon.component';
import { ICONS_PATH } from './icons-path.token';

@NgModule({
    imports: [CommonModule],
    providers: [{ provide: ICONS_PATH, useValue: 'assets/icons/svg' }],
    declarations: [FcpIconComponentSVGComponent],
    exports: [FcpIconComponentSVGComponent]
})
export class FcpIconModuleSVG {}
